import { apiClient } from "../api/apiClient.js";

// Thin fetch wrappers over the Prompt 112 Backoffice Latest Tracking read
// API. Both routes live on BackofficeTrackingController - the same
// Bearer-session-authenticated backend/base as every other backoffice
// controller (BackofficeAssignmentsController, BackofficeOnboarding, etc.),
// so this file calls apiClient.get with no `base` override, exactly like
// ../assignments/assignmentsApi.js and ../matchingQueue/matchingQueueApi.js
// - never the separate "trackingRead" base kind apiClient.js also exposes,
// which is reserved for a future, different tracking-read target and is not
// what P112 actually built. This file only ever calls the two real P112
// read routes - it never calls a mobile ingestion/geofence/fake-location/
// face-recognition/SOS API (none of those exist anywhere in this codebase),
// and it never sends a write.

const TRACKING_PATH = "/backoffice/tracking/workers";

// Exactly the query param names BackofficeTrackingController.ListLatest
// declares, in the same order as the controller signature - anything else
// passed to listLatestTracking is silently dropped rather than forwarded,
// so a typo'd key (or a future filter added to the UI without updating this
// whitelist) can never accidentally reach the backend as an unfiltered
// pass-through. Visibility scoping (Agent/PLC/SuperAgent/SuperAdmin) always
// happens on the backend from the caller's own session, never from a value
// this file sends.
const LATEST_TRACKING_LIST_PARAM_KEYS = [
  "search",
  "superAgentOrganizationId",
  "plcOrganizationId",
  "agentId",
  "employerId",
  "overallStatus",
  "heartbeatState",
  "page",
  "pageSize",
];

/** Builds a query string with every empty/null/undefined value omitted entirely (never sent as `key=`), restricted to `paramKeys`. */
function buildQuery(paramKeys, params = {}) {
  const searchParams = new URLSearchParams();
  for (const key of paramKeys) {
    const value = params[key];
    if (value === null || value === undefined || value === "") {
      continue;
    }
    searchParams.set(key, String(value));
  }
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export function listLatestTracking(params = {}) {
  return apiClient.get(`${TRACKING_PATH}/latest${buildQuery(LATEST_TRACKING_LIST_PARAM_KEYS, params)}`);
}

// Detail fetch requires a real, non-empty workerId - this file never issues
// a request for a missing/blank id (the caller only calls this once a
// row/card is actually clicked).
export function getLatestTrackingDetail(workerId) {
  if (!workerId) {
    throw new Error("getLatestTrackingDetail requires a workerId");
  }
  return apiClient.get(`${TRACKING_PATH}/${encodeURIComponent(workerId)}/latest`);
}
